import { dynamicUaParser } from './dynamics/ua-parser'
import { isBrowser } from './env'

export async function cacheUaParser(userAgent?: string) {
  if (isBrowser() && window._browserInfo) {
    return window._browserInfo
  }

  const uaParser = await dynamicUaParser((UAParser) => {
    return new UAParser(userAgent)
  })
  return uaParser.getBrowser()
}
